import { ReactNode } from 'react';
import { CircularProgress, ButtonProps, Button } from '@mui/material';
import { CircularProgressContainer } from './styled';

type Props = ButtonProps & {
  children: ReactNode;
  loading?: boolean;
  disabled?: boolean;
};

const LoadingButton = ({ children, loading, disabled, ...rest }: Props) => (
  <Button disabled={loading || disabled} {...rest}>
    {children}
    {loading && (
      <CircularProgressContainer>
        <CircularProgress color="inherit" size={24} />
      </CircularProgressContainer>
    )}
  </Button>
);

LoadingButton.defaultProps = {
  loading: false,
  disabled: false,
};

export default LoadingButton;
